module.exports = __webpack_public_path__ + "components/flag/static/square/lr-a3655d21724f3ccca8d003814d054d41.svg";